module.exports = __webpack_public_path__ + "img/1522176346.a2bd4f21.jpg";